// const statuses = ['Todo', 'In Progress', 'Ready For Inspection', 'Approved', 'Rejected'];
const statuses = ['Todo', 'In progress', 'Ready for review', 'Closed'];

export default statuses;
